import React, { FC, memo, useContext } from 'react'

import { Price as PriceDefinition, Product } from '@Generated/graphql'
import { useLocale } from '@Globals/Locale'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'

import styles from './TitleAndPrice.module.scss'

type TitleAndPriceProps = Pick<Product, 'name'> & Pick<Product, 'id'> & {
  price?: PriceDefinition
}

export const TitleAndPrice: FC<TitleAndPriceProps> = memo(({ id, name, price }) => {
  const { t } = useTranslation()
  const locale = useLocale()
  const { store } = useContext(MetadataContext)
  const isGiftCard = `${id}` === '26342'
  const showDutiesExclSalesTax = ['27', '36', '29', '28', '32'].includes(store.id)

  const beforePrice = (price?.discount?.format ? price.format : undefined) || undefined
  const currentPrice = price?.discount?.format || price?.format || ''

  return (
    <div className={styles.wrapper}>
      <div className={styles.titleWrapper}>
        <h1 className={styles.title}>
          {name}
        </h1>

        {!isGiftCard && price && (
          <div className={styles.priceWrapper}>
            {beforePrice && (
              <span className={styles.beforePrice}>{beforePrice}</span>
            )}
            <span className={styles.currentPrice}>
              {currentPrice}
            </span>
          </div>
        )}
      </div>

      {locale === 'nb-NO' && (
        <aside className={styles.taxMessage}>{t('products:INCLUDING_VALUE_ADDED_TAX')}</aside>
      )}
      {showDutiesExclSalesTax && (
        <aside className={styles.taxMessage}>{t('common:DUTIES_EXCL_SALES_TAX')}</aside>
      )}
    </div>
  )
})
